import { formConstants } from '../../../../utils/constants/form-constants';

const UserAddressesDisplayFormData = (accountFormData) => {
    function buildUserAddressesDisplayFormData() {
        const { ssoUserAddressesFields, ssoUserDetailsFields } = accountFormData;
        const formData = {};
        const {
            formTitle,
            noAddressFoundText,
            addAddressCallBackUrl,
            addAddressActionSuccessText,
            updateAddressCallBackUrl,
            updateAddressActionSuccessText,
            cannotRemoveLastAddressMessage,
            cannotRemoveMainAddressMessage,
            cannotRemoveShippingAddressMessage,
            cannotRemoveBillingAddressMessage
        } = ssoUserAddressesFields;

        formData[formConstants.formTitle] = formTitle;
        formData[formConstants.noAddressFoundText] = noAddressFoundText;
        formData[formConstants.addAddress] = {};
        formData[formConstants.addAddress][formConstants.callBackUrl] = addAddressCallBackUrl;
        formData[formConstants.addAddress][formConstants.actionSuccessText] = addAddressActionSuccessText;

        formData[formConstants.updateAddress] = {};
        formData[formConstants.updateAddress][formConstants.callBackUrl] = updateAddressCallBackUrl;
        formData[formConstants.updateAddress][formConstants.actionSuccessText] = updateAddressActionSuccessText;

        formData[formConstants.cannotRemoveLastAddressMessage] = cannotRemoveLastAddressMessage;
        formData[formConstants.cannotRemoveMainAddressMessage] = cannotRemoveMainAddressMessage;
        formData[formConstants.cannotRemoveShippingAddressMessage] = cannotRemoveShippingAddressMessage;
        formData[formConstants.cannotRemoveBillingAddressMessage] = cannotRemoveBillingAddressMessage;

        formData[formConstants.country] = ssoUserAddressesFields[formConstants.country];
        formData[formConstants.country].options = ssoUserDetailsFields[formConstants.country].options;

        formData[formConstants.county] = ssoUserAddressesFields[formConstants.county];
        formData[formConstants.county].options = ssoUserDetailsFields[formConstants.county].options;

        formData[formConstants.state] = ssoUserAddressesFields[formConstants.state];
        formData[formConstants.state].options = ssoUserDetailsFields[formConstants.state].options;

        formData[formConstants.city] = ssoUserAddressesFields[formConstants.city];
        formData[formConstants.addressLine1] = ssoUserAddressesFields[formConstants.addressLine1];
        formData[formConstants.addressLine2] = ssoUserAddressesFields[formConstants.addressLine2];
        formData[formConstants.addressLine3] = ssoUserDetailsFields[formConstants.addressLine3];
        formData[formConstants.postcode] = ssoUserAddressesFields[formConstants.postcode];

        formData[formConstants.mainAddress] = ssoUserAddressesFields[formConstants.mainAddress];
        formData[formConstants.shippingAddress] = ssoUserAddressesFields[formConstants.shippingAddress];
        formData[formConstants.billingAddress] = ssoUserAddressesFields[formConstants.billingAddress];

        formData[formConstants.removeAddressInputText] = ssoUserAddressesFields[formConstants.removeAddressInputText];
        formData[formConstants.removeAddressModalWarning] = ssoUserAddressesFields[formConstants.removeAddressModalWarning];

        return formData;
    }


    return buildUserAddressesDisplayFormData();
};

export default UserAddressesDisplayFormData;
